import React, { useEffect, useRef, useState } from "react";
import "../styles/About.css";
import HoverCards from "./HoverCards";
import AboutSection7 from "./AboutSection7";

const About = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.3 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);

  return (
    <div className="A_sec">
      <div className="A_sec1">
        <span>About Us</span>
        <h1> Welcome to Arshil</h1>
        <p>
          Arshil was founded on this simple promise - To craft secure, reliable,
          and scalable technology solutions for businesses of all sizes. We
          believe that happy employees are the key to happier customers.
        </p>
      </div>

      {/* A- sec3 */}

      <div className="A_sec3">
        <section className="A_sec3_left">
          <img className="Sec3_img" src="images/Sec2_img.png" alt="" />
        </section>
        <section className="A_sec3_right">
          <h5>
            About <span className="A_sec3_right_span">Arshil</span>
          </h5>
          <p>
            Arshil is a privately owned company, headquartered in Ashburn,
            Virginia, US, with offices in Hyderabad, India and Ontario Canada.
            We specialize in providing IT consulting services, building,
            implementing, and optimizing software solutions at a rapid pace, and
            providing staff augmentation in a variety of Information Technology
            roles
          </p>
          <p>
            We strive to prioritize speed and accuracy without compromising on
            quality when developing custom applications, enhancing existing
            systems or deploying new technologies. In 2024 we officially
            launched Akscel, a code generator and app development platform. This
            powerful tool streamlines mobile and web application development by
            producing accurate enterprise-standard compliant code.
          </p>
        </section>
      </div>

      {/* Sec 2 */}

      <div className="A_sec2">
        <div className="A_sec2_left">
          <h2>Our Story</h2>
          <p>
            The journey began in 2014 when our CEO, Mobeena Sheik, and Akbar
            Sheik, CTO, made a commitment to using their technical expertise to
            make a global impact. Together, they brought over two decades of
            experience, including working with Fortune 500 companies like FedEx
            and Hilton Worldwide and collaborating with reputable startups. By
            2024, Arshil had grown into a global organization with team members
            in India, the US, the UK, and Nigeria.
          </p>
          <div className="A_sec2_courosals_C">
            <section className="A_sec2_courosals_C_cardC">
              <section className="A_sec2_courosals_C_cardC_imgC">
                <img src="images/A_sec2_Akbar_img.png" alt="" />
              </section>
              <section className="A_sec2_courosals_C_cardC_bottom">
                <p>
                  "We value our people and believe that if we have the right
                  people with the right attitude, we can be very successful"
                </p>
                <h5>- Akbar Sheik, CTO & Co-founder</h5>
              </section>
            </section>
          </div>
        </div>
      </div>

      {/* A-sec4 */}

      <div className="A_sec4">
        <h1>Mission and Vision</h1>

        <section className="A_sec4_bottom">
          <section className="A_sec4_left">
            <img className="A_sec4_img1" src="images/A_sec4_img1.png" alt="" />
            <h5>Mission</h5>
            <p>
              To provide innovative, scalable, and secure technology solutions
              that enable organizations to thrive in a digital world while
              fostering a culture of collaboration, excellence, and success.
            </p>
          </section>
          <section className="A_sec4_left">
            <img className="A_sec4_img1" src="images/A_sec4_2.png" alt="" />
            <h5>Vision</h5>
            <p>
              To empower businesses around the world to innovate and grow
              through cutting-edge technology solutions that drive impact and
              transform industries.
            </p>
          </section>
        </section>
      </div>

      {/* Section 5 */}

      <div className="A_sec5">
        <section className="A_sec5_top">
          <h2>Our Core Values</h2>
          <p>
            In 2023, our CTO ignited a new chapter for Arshil with the
            introduction of our mantra, “Doing the Right Thing.” Since then,
            this simple yet powerful principle has become our guiding light,
            shaping everything we do.
          </p>
        </section>
        <HoverCards />
      </div>

      {/* Section 6 */}

      <div ref={sectionRef} className={`A_sec6 ${isVisible ? "fade-in" : ""}`}>
        <section className="A_sec6_one">
          {" "}
          <h2>Our Journey So Far</h2>
          <p>
            Over the past decade, we have partnered with global companies across
            the US and India, developing solutions and cutting-edge technologies
            to drive growth and scale their businesses.
          </p>
        </section>
      </div>

      {/* Section 7 */}

      <AboutSection7 />

      {/* Section 9 */}

      <div className="A_sec9">
        <section className="A_sec9_one">
          <h2>Where We Work</h2>
          <p>
            At Arshil, our fully remote and globally distributed team reflects
            our belief in flexibility and freedom. Curious to see where our team
            is making an impact? Explore the map to discover where Arshil’s
            innovators call home.
          </p>
          <h6>30+ teammates  6 Cities, 5 countries</h6>
        </section>

        <section>
          <img className="A_sec9_imgs" src="images/A_sec9_imgs.png" alt="" />
          <img
            className="A_sec9_imgtab"
            src="images/A_sec9_tabimg.png"
            alt=""
          />
        </section>
      </div>
    </div>
  );
};

export default About;
